
(function () {
  'use strict';

  angular.module('ringbaPortal').component('callTrackingTagForm', {
    bindings: {
      currentCampaign: '<',
      campaignCountry: '<',
      tag: '<',
      onDismiss: '&',
      onUpdate: '&'
    },
    controller: CallTrackingTagFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/call-tracking-tag/call-tracking-tag-form.view.html'
  });

  function CallTrackingTagFormController(
    _,
    $q,
    $translate,
    accountsService,
    callTrackingTagService,
    numberPoolService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.isUpdate = false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.handleSubmit = handleSubmit;
    vm.cancelAddNew = cancelAddNew;
    vm.validateForm = validateForm;


    function onInit() {
      _loadNumberPools();
      vm.availableNumbers = _filterAvailableNumbers();
    }

    function onChanges(changesObj) {
      const nextCampaign = changesObj && changesObj.currentCampaign ? changesObj.currentCampaign.currentValue : null;
      if (nextCampaign) {
        vm.availableNumbers = _filterAvailableNumbers();
      }

      const nextTag = changesObj && changesObj.tag ? changesObj.tag.currentValue : null;
      if (!nextTag) {
        return;
      }

      vm.callTrackingTag = angular.copy(vm.tag);
      if(vm.callTrackingTag.id) {
        vm.isUpdate = true;
        vm.callTrackingPool = vm.callTrackingTag.numberPool;
        vm.callTrackingTag.hasNumberPool = vm.callTrackingTag.numberPool != null;
      }
    }

    function handleSubmit() {
      if (vm.callTrackingTag) {
        if(vm.callTrackingTag.id) {
          return _updateTag(vm.callTrackingTag);
        } else {
          return _generateNewTag();
        }
      }
    }

    function cancelAddNew() {
      const eventObj = vm.callTrackingTag ? {
        tag: vm.callTrackingTag
      } : {};
      vm.onDismiss({
        $event: eventObj
      });
    }

    function validateForm(form) {
      // Enable button on error in Phone Number field if it's set to '+' only, else disable the button on the number being invalid
      // If the phone number is just '+', it's valid else if it has more than just a '+', it'll be validated normally
      if (!form.$invalid || (form.$error && form.$error.ngIntlTelInput && form.$error.ngIntlTelInput[0].$name === 'phoneNumber' && form.phoneNumber.$viewValue === '+' && Object.keys(form.$error).length === 1)) {
        return true;
      } else if (form.$invalid) {
        return false;
      }
    }

    function _generateNewTag() {
      vm.callTrackingTag.numberPoolId = vm.callTrackingTag.hasNumberPool ? vm.callTrackingPool.id : null;
      return callTrackingTagService.createCallTrackingTag(accountsService.currentAccountId, vm.currentCampaign.id, vm.publisherNumber.affiliate.id, vm.publisherNumber.id, vm.callTrackingTag)
        .then(function (response) {
          toaster.pop('success', $translate.instant('CALL_TRACKING_TAGS_GENERATE_SUCCESSFUL'));
          vm.callTrackingTag.id = _.find(response.data.campaign.affiliateNumbers, {
            id: vm.publisherNumber.id
          }).jsTagId;
          vm.callTrackingTag.number = vm.publisherNumber;
          vm.callTrackingTag.numberPool = vm.callTrackingTag.hasNumberPool ? vm.callTrackingPool : null;
          vm.onDismiss({
            $event: {}
          });
          vm.onUpdate({
            $event: {
              tag: vm.callTrackingTag
            }
          });
        })
        .catch(utils.errorHandler);
    }

    function _updateTag(callTrackingTag) {
      return callTrackingTagService.updateCallTrackingTag(accountsService.currentAccountId, callTrackingTag.campaignId, callTrackingTag.publisherId, callTrackingTag.numberId, callTrackingTag.id, callTrackingTag.name, callTrackingTag.e164ExistingNumber, vm.callTrackingPool?.id, vm.callTrackingTag.hasNumberPool)
        .then(function () {
          toaster.pop('success', $translate.instant('CALL_TRACKING_TAGS_UPDATE_SUCCESSFUL'));
          vm.onDismiss({
            $event: {}
          });
          vm.onUpdate({
            $event: {
              tag: vm.callTrackingTag
            }
          });
        })
        .catch(utils.errorHandler);

    }

    function _loadNumberPools() {
      numberPoolService.getNumberPools(accountsService.currentAccountId)
        .then(function (response) {
          vm.numberPools = _.filter(response.data.numberPools, function (o) {
            return o.assignmentSettings && o.assignmentSettings.countryCode === vm.campaignCountry;
          });
        })
        .catch(utils.errorHandler);
    }

    function _filterAvailableNumbers() {
      const campaignNumbers = vm.currentCampaign && vm.currentCampaign.affiliateNumbers ? vm.currentCampaign.affiliateNumbers : [];
      return _.filter(campaignNumbers, function (number) {
        return !number.jsTagId;
      });
    }

  }
})();
